const ERROR_FATAL = 4
const ERROR_CRITICAL = 3
const ERROR_NORMAL = 2
const ERROR_LOW = 1
const ERROR_NONE = 0

module.exports = {
  ERROR_FATAL,
  ERROR_CRITICAL,
  ERROR_NORMAL,
  ERROR_NONE,

  login_auth_failed: {
    level: ERROR_NONE,
    message: '登陆验证失败',
    details: '请确认用户名与密码后重试',
  },
  login_network_failed: {
    level: ERROR_LOW,
    message: '请求失败',
    details: '请确认网络连接后重试',
  },
}



// WEBPACK FOOTER //
// ./shared/errors.js